"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Disposable = _interopRequireDefault(require("../Disposable.js"));

var _Polygon = _interopRequireDefault(require("../geom/Polygon.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module ol/render/Box
 */
var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var RenderBox =
/** @class */
function (_super) {
  __extends(RenderBox, _super);
  /**
   * @param {string} className CSS class name.
   */


  function RenderBox(className) {
    var _this = _super.call(this) || this;
    /**
     * @type {import("../geom/Polygon.js").default}
     * @private
     */


    _this.geometry_ = null;
    /**
     * @type {HTMLDivElement}
     * @private
     */

    _this.element_ = document.createElement('div');
    _this.element_.style.position = 'absolute';
    _this.element_.style.pointerEvents = 'auto';
    _this.element_.className = 'ol-box ' + className;
    /**
     * @private
     * @type {import("../PluggableMap.js").default|null}
     */

    _this.map_ = null;
    /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */

    _this.startPixel_ = null;
    /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */

    _this.endPixel_ = null;
    return _this;
  }
  /**
   * Clean up.
   */


  RenderBox.prototype.disposeInternal = function () {
    this.setMap(null);
  };
  /**
   * @private
   */


  RenderBox.prototype.render_ = function () {
    var startPixel = this.startPixel_;
    var endPixel = this.endPixel_;
    var px = 'px';
    var style = this.element_.style;
    style.left = Math.min(startPixel[0], endPixel[0]) + px;
    style.top = Math.min(startPixel[1], endPixel[1]) + px;
    style.width = Math.abs(endPixel[0] - startPixel[0]) + px;
    style.height = Math.abs(endPixel[1] - startPixel[1]) + px;
  };
  /**
   * @param {import("../PluggableMap.js").default|null} map Map.
   */


  RenderBox.prototype.setMap = function (map) {
    if (this.map_) {
      this.map_.getOverlayContainer().removeChild(this.element_);
      var style = this.element_.style;
      style.left = 'inherit';
      style.top = 'inherit';
      style.width = 'inherit';
      style.height = 'inherit';
    }

    this.map_ = map;

    if (this.map_) {
      this.map_.getOverlayContainer().appendChild(this.element_);
    }
  };
  /**
   * @param {import("../pixel.js").Pixel} startPixel Start pixel.
   * @param {import("../pixel.js").Pixel} endPixel End pixel.
   */


  RenderBox.prototype.setPixels = function (startPixel, endPixel) {
    this.startPixel_ = startPixel;
    this.endPixel_ = endPixel;
    this.createOrUpdateGeometry();
    this.render_();
  };
  /**
   * Creates or updates the cached geometry.
   */


  RenderBox.prototype.createOrUpdateGeometry = function () {
    var startPixel = this.startPixel_;
    var endPixel = this.endPixel_;
    var pixels = [startPixel, [startPixel[0], endPixel[1]], endPixel, [endPixel[0], startPixel[1]]];
    var coordinates = pixels.map(this.map_.getCoordinateFromPixelInternal, this.map_); // close the polygon

    coordinates[4] = coordinates[0].slice();

    if (!this.geometry_) {
      this.geometry_ = new _Polygon["default"]([coordinates]);
    } else {
      this.geometry_.setCoordinates([coordinates]);
    }
  };
  /**
   * @return {import("../geom/Polygon.js").default} Geometry.
   */


  RenderBox.prototype.getGeometry = function () {
    return this.geometry_;
  };

  return RenderBox;
}(_Disposable["default"]);

var _default = RenderBox;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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